import request from "@/utils/request";
import {API_USER_INFO} from '@/utils/constant';

const state = () => ({
    inGame:false,
	userInfo:{},
	token:null,
	areas:[],
	localArea:{
		name:"Singapore",
		value: '65',
	},
	data:{
		notifications:[]
	},
	mileData:{
		mostExpensiveSold: 0,
		nftMintAmount: 0,
		nftTradeVolume: 0,
		registerUsers: 0
	},
	lang: 'en'
	// userInfo:{user_id:122}
})

const mutations = {
	// 修改多语言
	setLang(state, lang) {
		state.lang = lang;
	},

	setMileData(state, data) {
		state.mileData = {...data, mostExpensiveSold:1500000};
	},

	addNotify(state, notify) {
		notify.hash = new Date().valueOf();
		let notifications = [...state.data.notifications];
		notifications.push(notify);
		state.data.notifications = notifications;
	},

	removeNotify(state) {
		let notifications = [...state.data.notifications];
		notifications.shift();
		state.data.notifications = notifications;
	},

	setAreas(state, areas){
		state.areas = areas;
	},

	setLocalArea(state, localArea){
		state.localArea = localArea;
	},

	// 修改多语言
	setInGame(state, inGame) {
		state.inGame = inGame;
	},

	// 退出登录
	logout(state) {
		window.localStorage.removeItem('token');
		// CommonMethod.methods.postMessage('logout', '');
		// state.token = null;
		state.userInfo = {};
	},

	setToken(state, token){
		console.log("gb state")
		console.log(token)

		window.localStorage.setItem('token', token);
		state.token = token;
	},

	// 设置用户信息
	setUserInfo(state, userInfo) {
		console.log(userInfo);
		const newUserInfo = {
			...state.userInfo,
			...userInfo,
		};
		state.userInfo = newUserInfo;
		// CommonMethod.methods.postMessage('setUserInfo', newUserInfo);
	},
}

const actions = {
	async getUserInfo(context) {
		try{
			context.dispatch('getBaseUserInfo');
		} catch(_){
			console.log('error')
		}
		
	},
	async getBaseUserInfo(context) {
		try {
			console.log("call me daddy")

			const res = await request(API_USER_INFO, {
				method: 'POST',
			});

			console.log(res)

			context.commit('setUserInfo', res.data);
		} catch(_) {
			// context.commit("globalState/addNotify", {
			// 	msg: 'Error',
			// 	type: 'error',
			// }, { root: true });
		}
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
};